import { NgModule } from '@angular/core';
import { WaitTimeDurationPipe } from './wait-time-duration-duration.pipe';

@NgModule({
   declarations: [WaitTimeDurationPipe],
   exports: [WaitTimeDurationPipe],
})
export class WaitTimeDurationPipeModule {}
